import { defineComponent, h } from 'vue';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { fromUnixTimestamp, d } from '@/ui/i18n/i18n';

export const ConductedAt = defineComponent({
  name: 'ConductedAt',
  setup() {
    const { resource } = useInspectionReport();

    return function render() {
      return h('div', [
        resource.value?.conducted_at
          ? d(fromUnixTimestamp(resource.value.conducted_at) as unknown as Date)
          : null,
      ]);
    };
  },
});
